export default "__VITE_ASSET__B9gg464m__"